// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */
import { i18n as initI18n, i18nObject as initI18nObject, i18nString as initI18nString } from 'typesafe-i18n';
import { detectLocale as detectLocaleFn } from 'typesafe-i18n/detectors';
import { initExtendDictionary } from 'typesafe-i18n/utils';
export const baseLocale = 'en';
export const locales = [
    'cs', 'da', 'de', 'en', 'es', 'et', 'fi', 'fr', 'hu', 'is', 'it', 'nb', 'nl', 'pt', 'ro', 'sv'
];
export const isLocale = (locale) => locales.includes(locale);
export const loadedLocales = {};
export const loadedFormatters = {};
export const extendDictionary = initExtendDictionary();
export const i18nString = (locale) => initI18nString(locale, loadedFormatters[locale]);
export const i18nObject = (locale) => initI18nObject(locale, loadedLocales[locale], loadedFormatters[locale]);
export const i18n = () => initI18n(loadedLocales, loadedFormatters);
export const detectLocale = (...detectors) => detectLocaleFn(baseLocale, locales, ...detectors);
